import {Message, MessageType} from "../api/Models";
import React from "react";
import {useAppSelector} from "../hooks";
import {selectMembers} from "../redux/members";

type MessageProps = {
  message: Message
}

export default function MessageComponent ({ message }: MessageProps) {
  const members = useAppSelector(selectMembers)

  let prefix: string|null = null;
  let authorName: string|null = message.authorIds.map((authorId) => {
    const member = members.find((m) => m.id === authorId)
    if (!member) {
      throw new Error('Unknown author: ' + authorId)
    }
    return member
  }).map((a) => a.name).join(', ')

  if (message.type === MessageType.Success) {
    authorName = null
    prefix = '✅';
  } else if (message.type === MessageType.Notice) {
    authorName = null
    prefix = 'ℹ️'
  } else if (message.type === MessageType.Error) {
    authorName = null
    prefix = '❌';
  }

  const authorPrefix = authorName ? `${authorName}: ` : ''

  return (
    <div className={'message'}>
      {prefix && `${prefix} `}
      <span style={{
        color: prefix ? '#aaa' : '#eee',
        fontStyle:prefix ? 'italic' : 'inherit'
      }}>{authorPrefix}{message.entry}</span>
    </div>
  )
}

